import $ from 'jquery'

class Module {
  constructor ($module) {
    
    try {
      const item = $(window.location.hash, $module)
  
      if (item) {
        item.addClass('open').find('.sub-collapse').addClass('sub-collapse__open')
      }
      
    } catch (e) {
      console.log(e)
    }
    
    $module.find('.js-toggler').on('click', function () {
      const hash = '#' + $(this).data('slug')

      if ('replaceState' in history) {
        history.replaceState('', '', hash)
      } else {
        window.location.hash = hash
      }
    })
  }
}

$(function () {
  $('.js-qa').each(function () {
    new Module($(this))
  })
})
